import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../../styles/alert.css";

export const AppAlert = ({
    caption,
    message,
    accept,
    reject,
    onAccept,
    onReject,
    onClose
}) => {
    return (
        <div className="alert-bg">
            <div className="alert-container">
                <div className="alert-top-box">
                    <div className="alert-caption">{caption}</div>
                    <div className="button-box">
                        <button 
                            className="tr-btn cl-button"
                            onClick={onClose}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                </div>
                <div className="alert-message-box">
                    {message}
                </div>
                <div className="alert-button-box">
                    {accept && (
                        <button 
                            className="alert-button accept"
                            onClick={onAccept}
                        >
                            {accept}
                        </button>
                    )}
                    {reject && (
                        <button 
                            className="alert-button reject"
                            onClick={onReject}
                        >
                            {reject}
                        </button>
                    )}
                </div>
            </div>
        </div>
    )
}